import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';


export interface LoaderCSSStyle extends UIComponentCSSStyle
{
    getImgCSSStyle(): object;
}

export class LoaderCSSStyleImpl extends UIComponentCSSStyleImpl implements LoaderCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
              position: "relative",
              display: 'flex',
              alignItems: 'center',
            justifyContent: 'center',
              width: "100px",
              height: "100px",
              top: 0,
              left: 0,
        };
      }

    getImgCSSStyle(): object 
    {
        return {
                border: "16px solid #f3f3f3",
                borderRadius: "50%",
                borderTop: "16px solid #3498db",
                width: "100px",
                height: "100px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/loader/loadercss.tsx